module.exports = fox._r("flash/amc82.swf", __webpack_public_path__ + "_/_/_/common/frame/flash/amc82.swf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/flash/amc82.swf
// module id = 213
// module chunks = 2